import { Reducer } from "../../lib/redux";
import { HosLogActions, HistoricalDayActions } from "./actions";
import { SystemHosLogActionTypes, UserHosLogActionTypes, HistoricalDayActionTypes, IHistoricalDayEntry, IHistoricalDayTracker } from "./types";
import DutyStatusLog from "../../model/DutyStatusLog";
import { extend } from "../../utils/vanilla";

export const defaultUserHosLogs: IIdDictionary<IIdDictionary<DutyStatusLog>> = {};
export const defaultSystemHosLogs: IIdDictionary<IIdDictionary<DutyStatusLog>> = {};

export const userHosLogs: Reducer<IIdDictionary<IIdDictionary<DutyStatusLog>>, HosLogActions> = (state = defaultUserHosLogs, action) => {
    switch (action.type) {
        case UserHosLogActionTypes.SET_USER_HOS_LOGS: {
            const userId = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: extend(true, {}, action.payload.logs)
                };
            }
            return state;
        }
        case UserHosLogActionTypes.CLEAR_USER_HOS_LOGS: {
            if (action.payload && action.payload.length > 0) {
                return Object.keys(state)
                    .filter(userId => action.payload.map(user => user.id).indexOf(userId) !== -1)
                    .reduce((curr, key) => ({
                        ...curr,
                        [key]: state[key]
                    }), {});
            }
            return {};
        }
        default:
            return state;
    }
};


export const systemHosLogs: Reducer<IIdDictionary<IIdDictionary<DutyStatusLog>>, HosLogActions> = (state = defaultSystemHosLogs, action) => {
    switch (action.type) {
        case SystemHosLogActionTypes.SET_SYSTEM_HOS_LOGS: {
            const userId = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: extend(true, {}, action.payload.logs)
                };
            }
            return state;
        }
        case SystemHosLogActionTypes.CLEAR_SYSTEM_HOS_LOGS: {
            if (action.payload && action.payload.length > 0) {
                return Object.keys(state)
                    .filter(userId => action.payload.map(user => user.id).indexOf(userId) !== -1)
                    .reduce((curr, key) => ({
                        ...curr,
                        [key]: state[key]
                    }), {});
            }
            return {};
        }
        default:
            return state;
    }
};

export const defaultHistoricalDayTracker: IHistoricalDayTracker = {};

export const historicalDayTracker: Reducer<IHistoricalDayTracker, HistoricalDayActions> = (
    state = defaultHistoricalDayTracker,
    action
) => {
    switch (action.type) {
        case HistoricalDayActionTypes.TRACK_HISTORICAL_DAY: {
            const { userId, dateKey, loadedAt, hosLogs, systemLogs, violations, odometer } = action.payload;
            if (!userId || !dateKey || !loadedAt || !Array.isArray(hosLogs) || !Array.isArray(systemLogs) || !Array.isArray(violations)) {
                return state;
            }

            const entry: IHistoricalDayEntry = {
                loadedAt,
                hosLogs: extend(true, [], hosLogs),
                systemLogs: extend(true, [], systemLogs),
                violations: extend(true, [], violations),
                // Optional for backward-compat with entries cached before odometer support.
                odometer: extend(true, {}, odometer ?? {})
            };
            return {
                ...state,
                [userId]: {
                    ...(state[userId] || {}),
                    [dateKey]: entry
                }
            };
        }
        case HistoricalDayActionTypes.UNTRACK_HISTORICAL_DAY: {
            const { userId, dateKey } = action.payload;
            if (!userId || !dateKey || !state[userId]) {
                return state;
            }

            const { [dateKey]: removed, ...rest } = state[userId];
            return {
                ...state,
                [userId]: rest
            };
        }
        case HistoricalDayActionTypes.CLEAR_TRACKED_DAYS: {
            if (action.payload && action.payload.length > 0) {
                const keepIds = new Set(action.payload.map(u => u.id));
                return Object.keys(state)
                    .filter(userId => keepIds.has(userId))
                    .reduce((curr, key) => ({ ...curr, [key]: state[key] }), {});
            }
            return {};
        }
        case HistoricalDayActionTypes.CLEAR_USER_TRACKED_DAYS: {
            const userId = action.payload;
            if (!userId || !state[userId]) {
                return state;
            }

            const { [userId]: removed, ...rest } = state;
            return rest;
        }
        default:
            return state;
    }
};